import { render, staticRenderFns } from "./SendEditMedicine.vue?vue&type=template&id=9f22d844&"
import script from "./SendEditMedicine.vue?vue&type=script&lang=js&"
export * from "./SendEditMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports